import type { SelectDesignTokens } from '@primeuix/themes/types/select'
import type { SelectButtonDesignTokens } from '@primeuix/themes/types/selectbutton'

import { bothSchemes } from '../utils'

/** Выпадающие списки (пол в настройках, район филиала). */
export const selectConfig = (): SelectDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-xl)',
    focusRing: { width: '0', style: 'none', offset: '0' },
  },
  dropdown: {
    width: '2.5rem',
  },
  overlay: {
    borderRadius: 'var(--radius-xl)',
    shadow: 'var(--shadow-card)',
  },
  list: {
    padding: 'var(--space-4)',
    gap: 'var(--space-1)',
  },
  option: {
    padding: 'var(--space-6) var(--space-7)',
    borderRadius: 'var(--radius-m)',
  },
  emptyMessage: {
    padding: 'var(--space-6) var(--space-7)',
  },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-muted)',
      disabledBackground: 'var(--secondary-100)',
      filledBackground: 'var(--surface-muted)',
      filledHoverBackground: 'var(--surface-muted)',
      filledFocusBackground: 'var(--surface-muted)',
      borderColor: 'transparent',
      hoverBorderColor: 'transparent',
      focusBorderColor: 'var(--secondary-200)',
      invalidBorderColor: 'var(--primary-500)',
      color: 'var(--text-color)',
      disabledColor: 'var(--text-color-secondary)',
      placeholderColor: 'var(--text-color-secondary)',
      shadow: 'none',
    },
    dropdown: { color: 'var(--icon-color)' },
    overlay: {
      background: 'var(--surface-card)',
      borderColor: 'transparent',
      color: 'var(--text-color)',
    },
    option: {
      color: 'var(--text-color)',
      focusBackground: 'var(--surface-muted)',
      selectedBackground: 'var(--accent-500)',
      selectedFocusBackground: 'var(--accent-500)',
      selectedColor: 'var(--accent-surface-color)',
      selectedFocusColor: 'var(--accent-surface-color)',
    },
  }),
})

/**
 * Сегмент-переключатель «Доставка / Заберу» и «Себе / Другому»:
 * 179x50, r=20, активный сегмент — #F7F7F7, лейбл 18 Bold.
 * Визуал сегментов доводится в styles/primevue.scss —
 * Aura рисует активный элемент отдельным .p-togglebutton-content.
 */
export const selectButtonConfig = (): SelectButtonDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-xl)',
  },
  colorScheme: bothSchemes({
    root: { invalidBorderColor: 'var(--primary-500)' },
  }),
})
